import React from 'react';
import { useInscreenObserver } from '../InscreenObserver';
import { SearchAdContextProvider } from './SearchAdContext';
import type { BaseSearchAdProps } from './SearchAdTypes';

type SearchAdProps = Pick<
    BaseSearchAdProps,
    | 'className'
    | 'favorite'
    | 'id'
    | 'mode'
    | 'onClick'
    | 'onFirstInscreen'
    | 'onMouseEnter'
    | 'onMouseLeave'
    | 'target'
    | 'url'
> & {
    adId: string;
    children?: React.ReactNode;
    legendary?: boolean;
    style?: React.CSSProperties;
};

export function SearchAd(props: SearchAdProps) {
    const {
        adId,
        children,
        className = '',
        favorite,
        legendary = false,
        id,
        mode,
        onClick,
        onFirstInscreen,
        onMouseEnter,
        onMouseLeave,
        style,
        target,
        url,
    } = props;

    const [inscreenRef] = useInscreenObserver({
        callback: onFirstInscreen,
        options: {
            once: true,
            threshold: 0.75,
            timeout: 1000,
        },
    });

    const headingId = `search-ad-${adId}`;

    const cardClass = `sf-search-ad card ${
        legendary
            ? 'p-10 hover:s-bg-info-subtle focus:s-bg-info-subtle sf-search-ad-legendary'
            : 'card--cardShadow'
    } ${className}`;
    const outlineClass =
        'outline-none rounded-8 border-2 border-transparent sf-search-ad-outline';

    return (
        <SearchAdContextProvider
            headingId={headingId}
            linkId={id}
            mode={mode}
            onClick={onClick}
            target={target}
            url={url}
        >
            <article
                ref={inscreenRef}
                className={`relative isolate ${cardClass}`}
                style={style}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <div className="absolute" aria-owns={headingId}></div>
                {children}
                {favorite && (
                    <span className="absolute top-8 right-8 z-10">
                        {favorite()}
                    </span>
                )}
                <div
                    className={`absolute inset-0 z-10 pointer-events-none ${outlineClass}`}
                ></div>
            </article>
        </SearchAdContextProvider>
    );
}
